<template>
    <div class="trade-detail">
        <div class="trade-title">
            <div class="title-line"></div>
            <span class="title-content">交易明细</span>
        </div>
        <el-table
            :data="tradeList"
            style="width: 100%"
            class="tab-list-tit"
            max-height="1000"
            :header-cell-style="{ background: '#F9F9F9' }"
        >
            <el-table-column label="产品名称" width="280" class-name="fund-offset">
                <template slot-scope="scope">
                    <div style="color: #333333">
                        {{ scope.row.fundname }}
                    </div>
                    <div style="color: #666666">
                        {{ scope.row.fundcode }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="交易类型" align="center">
                <template slot-scope="scope">
                    <span>{{ $cache.getDict("130010", scope.row.businesscode) }}</span>
                    <span v-if="scope.row.businesscode === '029'">
                        - {{ $cache.getDict("110001", scope.row.dividendmethod) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="交易时间" align="center">
                <template slot-scope="scope">
                    <div style="color: #333333">
                        {{ $util.fmtDate(scope.row.operdate) }}
                    </div>
                    <div style="color: #999999">
                        {{ $util.fmtTime(scope.row.opertime) }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="交易状态" align="center">
                <template slot-scope="scope">
                    <span>{{ formatterCfmStatus(scope.row) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="申请金额/份额" align="center">
                <template slot-scope="scope">
                    <span v-if="filterBusinessType.includes(scope.row.businesscode)">--</span>
                    <span v-else>
                        {{
                            $util.fmtNum(scope.row.appamount) +
                            (isBuyType(scope.row.businesscode) ? "元" : "份")
                        }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="确认金额/份额" align="center">
                <template slot-scope="scope">
                    <span>{{ formatterCfmAmount(scope.row) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="确认净值" align="center">
                <template slot-scope="scope">
                    <span>{{ $util.fmtNum(scope.row.nav, 4) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="手续费(元)" align="center">
                <template slot-scope="scope">
                    <span
                        v-if="
                            filterBusinessType.includes(scope.row.businesscode) ||
                            !['07', '09'].includes(scope.row.transstatus)
                        "
                    >
                        --
                    </span>
                    <span v-else>{{ $util.fmtNum(scope.row.charge) }}</span>
                </template>
            </el-table-column>
        </el-table>
        <el-row v-if="allPage > 0" class="pagination-box">
            <el-pagination
                :page-size="Number(conf.PAGE_SIZE)"
                :current-page.sync="curPage"
                layout="->, total, prev, pager, next"
                :total="Number(allPage)"
                v-on:current-change="dataRefresh"
            />
        </el-row>
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import fundApi from "@/api/fund";

export default {
    name: "AssetsTradeDetail",
    components: {},
    mixins: [mixin],
    props: {
        fundcode: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            conf: {}, // 初始化配置文件内容
            allPage: "",
            curPage: 1,
            tradeList: [], // 交易明细
            filterBusinessType: ["052", "029", "0F1"]
        };
    },
    watch: {
        fundcode() {
            this.getTradeList();
        }
    },
    methods: {
        // 获取交易明细
        async getTradeList() {
            if (!this.$cache.getBinded()) {
                return;
            }
            const _x = {
                assetdetail: this.fundcode,
                pagesize: "10",
                pagenum: this.curPage,
                appflag: "0",
                norbusinesscode: "052"
            };
            const res = await fundApi.qryOrderListService(_x);
            if (res.data) {
                this.allPage = res.data.total.toString();
                this.tradeList = res.data.data;
            }
        },
        // 切换分页
        dataRefresh() {
            this.getTradeList();
        },
        // 获取处理状态
        formatterCfmStatus(row) {
            let status = "";
            if (!this.$util.isEmpty(row.transstatus)) {
                status = this.$cache.getDict("120198", row.transstatus) || row.status;
            } else {
                if (!this.$util.isEmpty(row.paystatus)) {
                    if (row.paystatus == "00") {
                        status = "待支付";
                    } else if (row.paystatus == "01") {
                        status = "支付处理中";
                    } else if (row.paystatus == "07") {
                        status = "支付成功";
                    } else {
                        status = this.$cache.getDict("110077", row.paystatus);
                    }
                }
            }
            return status;
        },
        // 判断业务类型单位为元
        isBuyType(businesscode) {
            return ["143", "022", "039", "020", "059", "060"].includes(businesscode);
        },
        formatterCfmAmount(row, column, value) {
            if (
                this.filterBusinessType.includes(row.businesscode) ||
                !["07", "09"].includes(row.transstatus)
            ) {
                return "--";
            }
            if (row.businesscode === "036") {
                return row.targetconfirmedvol
                    ? "(转入)" + this.$util.fmtNum(row.targetconfirmedvol) + "份"
                    : "--";
            }
            return Number(row.confirmedamount) > 0
                ? this.$util.fmtNum(row.confirmedamount) + "元"
                : this.$util.fmtNum(row.confirmedvol) + "份";
        }
    }
};
</script>

<style lang="scss" scoped>
.trade-detail {
    box-sizing: border-box;
    .trade-title {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
    }
}
.el-table {
    border: 1px solid #f1f1f1;
}
.el-table--fit {
    margin-bottom: 0;
}
.el-table td.el-table__cell div {
    color: #333333;
}
.el-table td.el-table__cell span {
    color: #333333;
}
.pagination-box {
    text-align: center;
    padding: 10px 0 0;
}
.el-pagination {
    margin-bottom: 0;
}
</style>
